export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.19-1017.06",
  commitId: "3a3db1d43094abebf48f2303056fafedcc159121",
  commitTime: "2026-10-19T10:17:06.000Z",
});
